import React from 'react';

import './DualColorIcon.scss';

type DualColorSwatchIconProps = {
    secondaryColor: string;
};

const DualColorIcon = (props: DualColorSwatchIconProps) => {
    const { secondaryColor } = props;

    return (
        <div className="DualColorIcon">
            <svg className="diagonal-half-icon" viewBox="0 0 9 9" preserveAspectRatio="none">
                <polygon points="0,0 10,0 10,10" style={{ fill: secondaryColor }} />
            </svg>
        </div>
    );
};

export default DualColorIcon;
